import React from "react";
import __t from "../../lib/localization/index";

export default function Contact({ locale }) {
  return (
    <section className="newsletter section" id="contact-us">
      <hr/>
      <div className="container-sm">
        <div className="newsletter-inner section-inner">
          <div className="blog-post-intro">
            <h2>{__t("main_page_contact_us_h2", locale)}</h2>
            <p>{__t("main_page_contact_us_p", locale)}</p>
          </div>
          <a
            href="mailto:connect@textintoimages.com"
          >
            Send Mail to Us
          </a>
        </div>
      </div>
    </section>
  );
}
